import React from "react";
import PropTypes from "prop-types";

const ExpandIcon = ({ width = "20px" }) => (
  <div>
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={width}
    >
      <defs></defs>
      <path
        style={{ fill: "#505050", strokeWidth: "0px" }}
        d="M46,.15H4.34C2.04.15.17,2.01.17,4.31v41.67c0,2.3,1.87,4.17,4.17,4.17h41.67c2.3,0,4.17-1.87,4.17-4.17V4.31c0-2.3-1.87-4.17-4.17-4.17ZM38.71,27.23h-11.46v11.46c0,1.15-.93,2.08-2.08,2.08s-2.08-.93-2.08-2.08v-11.46h-11.46c-1.15,0-2.08-.93-2.08-2.08s.93-2.08,2.08-2.08h11.46v-11.46c0-1.15.93-2.08,2.08-2.08s2.08.93,2.08,2.08v11.46h11.46c1.15,0,2.08.93,2.08,2.08s-.93,2.08-2.08,2.08Z"
      />
    </svg>
  </div>
);

ExpandIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

export default ExpandIcon;
